import { REPORTS_TYPES } from 'constants/report';
import callAPiBase from './base';

const bpeApi = {
  getBpeConfig: ({ params }: { params: object }) =>
    callAPiBase({
      endpoint: '/bpeConfigGet',
      method: 'GET',
      useToken: true,
      title: 'BPE - Get settings',
      params,
    }),
  updateBpeConfig: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/bpeConfigUpdate',
      method: 'POST',
      useToken: true,
      title: 'BPE - settings - Update',
      data,
    }),
};

export { bpeApi };
export default bpeApi;
